import React from "react";

const SvgIcnSync = props => (
  <svg
    id="icn_sync_svg__\u30EC\u30A4\u30E4\u30FC_1"
    data-name="\u30EC\u30A4\u30E4\u30FC 1"
    width={24}
    height={24}
    {...props}
  >
    <defs>
      <style>{".icn_sync_svg__cls-1{fill:#4a4b4c}"}</style>
    </defs>
    <path
      className="icn_sync_svg__cls-1"
      d="M5 15.93L9.72 15l-1 1.77.4.25a6.25 6.25 0 0 0 3.4 1 6.32 6.32 0 0 0 6.31-6.31v-.35l2.27-.63a8.31 8.31 0 0 1 .06 1A8.6 8.6 0 0 1 8 19.06l-.44-.27-1 1.75zM3.94 12.72a8.31 8.31 0 0 1-.06-1A8.6 8.6 0 0 1 17 4.42l.44.27 1-1.75 1.57 4.61-4.77.93 1-1.77-.4-.25a6.25 6.25 0 0 0-3.4-1 6.32 6.32 0 0 0-6.31 6.31v.34z"
    />
  </svg>
);

export default SvgIcnSync;
